export const recurrenceList = [
  { id: "MONTHLY", name: "Mensal" },
  { id: "QUARTERLY", name: "Trimestral" },
  { id: "SEMIANNUAL", name: "Semestral" },
  { id: "YEARLY", name: "Anual" },
];
